// extracted by mini-css-extract-plugin
module.exports = {"button":"PButton_button__3LZ0G","compact":"PButton_compact__gW_xf"};